/*
 * @Author: dinglizu
 * @Date: 2022-04-22 20:34:54
 * @LastEditTime: 2022-10-06 11:42:42
 * @LastEditors: dinglizu
 * @Description: 
 */
//应用mutation
export const cleanUser = ({ commit }) => {
  commit("token", null)
  commit("userInfo", null)
  commit("orgInfo", null)
  // commit("toeflModel", {})
  // commit("testReport", null)
  // commit("browse", null)
  // commit("practice", null)
  // commit("card", null)
}
export const setToken = ({ commit }, token) => {
  commit("token", token)
}
export const setAliyunDeviceCode = ({ commit, state }, aliyunDeviceCode) => { 
  const codes = state.aliyunDeviceCode
  if(!codes.some(i => i.key == aliyunDeviceCode.key)){
    codes.push(aliyunDeviceCode)
  }
  commit("aliyunDeviceCode", codes)
}
export const setUserInfo = ({ commit }, userInfo) => {
  commit("userInfo", userInfo)
}
export const setToeflModel = ({ commit }, toeflModel) => {
  commit("toeflModel", toeflModel)
}
export const setTestReport = ({ commit }, testReport) => {
  commit("testReport", testReport)
}
export const setBrowse = ({ commit }, browse) => {
  commit("browse", browse)
}
export const setPractice = ({ commit }, practice) => {
  commit("practice", practice)
}
export const setCard = ({ commit }, card) => {
  commit("card", card)
}
export const setRouteName = ({ commit }, routeName) => {
  commit("routeName", routeName)
}
export const setGlobalConfig = ({ commit }, globalConfig) => {
  commit("globalConfig", globalConfig)
}

export const setOrgSetting = ({ commit }, orgInfo) => {
  commit("orgInfo", orgInfo)
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js